export default "__VITE_ASSET__B8p3DW6W__"